<script setup>
import { AbcHeading } from "@ordbogen-npm/abc-dsk";
import { useI18n } from "vue-i18n";

import ImageResponsive from "@/components/ImageResponsive.vue";
import ClassQuizBasePrompt from "@/components/vocabularyTrainer/ClassQuizBasePrompt.vue";

const props = defineProps({
  listName: {
    type: String,
    required: true
  }
});

const { t } = useI18n();
</script>

<template>
  <ClassQuizBasePrompt class="class-quiz-lobby-prompt row">
    <div
      class="col-lg-4 d-none d-lg-flex justify-content-start align-items-end class-quiz-lobby-prompt__image-container"
    >
      <ImageResponsive
        img-class="class-quiz-lobby-prompt__boy-image"
        src="/assets/img/vocab/game/boy-pointing@1x.png"
        presentational
      />
    </div>
    <div
      class="col-12 col-lg-4 d-flex justify-content-center align-items-center text-center flex-column class-quiz-lobby-prompt__text-container"
    >
      <p class="class-quiz-lobby-prompt__top-explainer">
        {{ t("vocab.classQuiz.lobby.topExplainer") }}
      </p>
      <AbcHeading tag="h1" size="xl">{{ props.listName }}</AbcHeading>
    </div>
    <div
      class="col-lg-4 d-none d-lg-flex justify-content-end align-items-end class-quiz-lobby-prompt__image-container"
    >
      <ImageResponsive
        img-class="class-quiz-lobby-prompt__girl-image"
        src="/assets/img/vocab/game/girl-pointing@1x.png"
        presentational
      />
    </div>
  </ClassQuizBasePrompt>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.class-quiz-lobby-prompt {
  #media-breakpoint-up(lg, {
    padding-bottom: 0;
  });

  &__text-container {
    #media-breakpoint-up(lg, {
      margin-top: -3vmin;
    });
  }

  &__top-explainer {
    margin-bottom: 0;
    color: rgb(@theme-colors[@secondary][base]);
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;

    #media-breakpoint-up(md, {
      font-size: 1.125rem;
      line-height: 1.75rem;
    });
  }
}

:deep(.class-quiz-lobby-prompt__boy-image) {
  max-height: 12.5vmin;
}

:deep(.class-quiz-lobby-prompt__girl-image) {
  max-height: 15vmin;
}
</style>
